import { v4 as uuidv4 } from "uuid";
import { uploadTypeForBucket, uploadUserDocumentToS3Async } from "api/document";
/** @typedef {import("elements/ANUploader").AcceptedFile} AcceptedFile */

/**
 * Uploads a file through the an-api backend to S3 (no direct AWS access in the
 * browser). The backend selects the bucket from `type` and performs the upload.
 *
 * @function postUploadFiles
 * @param {string} cognitoId - Unique identifier associated with a user.
 * @param {AcceptedFile[]} uploadFiles - Array of objects with a `file` property.
 * @param {string} [S3Bucket] - Legacy bucket name; mapped to backend `type`
 *   via `uploadTypeForBucket` (SMS → "MMS", assessment batch → "ASSESSMENT_BATCH",
 *   otherwise "USER_DOC").
 * @returns {Promise<{ errors: any, success: string | null }>} `success` holds the
 *   uploaded object Key on success.
 */
export async function postUploadFiles(cognitoId, uploadFiles, S3Bucket) {
  let errors = null;
  let success = null;

  try {
    if (uploadFiles[0]?.file) {
      const file = uploadFiles[0].file;
      const fileUUID = uuidv4();
      const lastDotIndex = file.name.lastIndexOf(".");
      const fileName = lastDotIndex === -1 ? file.name : file.name.slice(0, lastDotIndex);
      const fileExtension = lastDotIndex === -1 ? "" : file.name.slice(lastDotIndex + 1);
      const key = fileExtension
        ? `${cognitoId}/${fileName}-${fileUUID}.${fileExtension}`
        : `${cognitoId}/${fileName}-${fileUUID}`;
      const type = uploadTypeForBucket(S3Bucket);

      const response = await uploadUserDocumentToS3Async({
        file,
        key,
        type,
        contentType: file.type,
        ...(type !== "MMS" ? { acl: "authenticated-read" } : {}),
      });

      if (response?.data?.Key) {
        success = response.data.Key;
      }
    }
  } catch (error) {
    console.log(error);
    errors = error;
  }

  return { errors, success };
}
